function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 2H5.84615C4.82814 2 4 2.67287 4 3.5C4 4.32713 4.82814 5 5.84615 5H20V2Z",
  fill: "#0F2E43"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 6.60394H5.84615C5.15069 6.60394 4.51577 6.37375 4 6V20.2326C4 21.2072 4.82814 22 5.84615 22H20V6.60394ZM17.5385 15.441C17.5385 16.4322 16.4567 17.2084 15.0769 17.2084C13.6971 17.2084 12.6154 16.4322 12.6154 15.441C12.6154 14.4497 13.6971 13.6736 15.0769 13.6736C15.5307 13.6736 15.9463 13.764 16.3077 13.912V10.4195L11.3846 12.3048V17.7975C11.3846 18.7888 10.3029 19.5649 8.92308 19.5649C7.54326 19.5649 6.46154 18.7888 6.46154 17.7975C6.46154 16.8062 7.54326 16.0301 8.92308 16.0301C9.37686 16.0301 9.79245 16.1206 10.1538 16.2685V11.5075L17.5385 8.67974V15.441Z",
  fill: "#0F2E43"
});

var SvgPackageInfo = function SvgPackageInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPackageInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/package-info.b240e6a5.svg";
export { ForwardRef as ReactComponent };